import { Component, Injector } from '@angular/core';
import { IonicPage, LoadingController, NavController, NavParams, ViewController } from 'ionic-angular';
import { Util } from '../../app/util';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the MjsospesiPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-mjsospesi',
  templateUrl: 'mjsospesi.html',
})
export class MjsospesiPage extends Util {
  mj: any;
  salvati = [];
  risposte;
  domande;
  constructor(public viewCtrl: ViewController, public navpar: NavParams, public inj: Injector, loading: LoadingController, public translate: TranslateService) {
    super(inj, loading);
    this.mj = this.navpar.get('mj');
    // console.log(this.mj);
    this.storage.get('mq_saved_' + this.mj.id+ '_'+this.gs.userx.id).then((ids_mq_saved) => {
      if (ids_mq_saved != null && ids_mq_saved != undefined) {
        ids_mq_saved.forEach(element => {
          // console.log('microquest_' + element);
          this.storage.get('microquest_' + element+ '_'+this.gs.userx.id).then((mq1) => {
            this.salvati.push(mq1);
          })
          
        });
      }
    })
    setTimeout(() => {
      // console.log(this.salvati);
    }, 2000);


  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad MjsospesiPage');
  }
  response(res) {
    this.viewCtrl.dismiss(res);
  }
  open_questionario(mqs){
    // console.log(mqs);
    this.storage.get('microquest_risposte_' + mqs.id+ '_'+this.gs.userx.id).then((mq_risposte) => {
      this.risposte = mq_risposte;
      this.storage.get('microquest_domande_' + mqs.id+ '_'+this.gs.userx.id).then((mq_domande) => {
        this.domande = mq_domande;
        this.viewCtrl.dismiss({mq:mqs,mj:this.mj,risposte:this.risposte,domande:this.domande});
      })
    })
   
    
  }
}



// WEBPACK FOOTER //
// ./src/pages/mjsospesi/mjsospesi.ts